// Preload components for faster navigation
export const preloadRoute = (route) => {
  switch(route) {
    case '/shop':
      import('../pages/Shop/Shop');
      break;
    case '/product':
      import('../pages/ProductDetail/ProductDetail');
      break;
    case '/cart':
      import('../pages/Cart/Cart');
      break;
    case '/checkout':
      import('../pages/Checkout/Checkout');
      break;
    case '/about':
      import('../pages/About/About');
      break;
    case '/contact':
      import('../pages/Contact/Contact');
      break;
    default:
      break;
  }
};

// Preload critical routes on idle
export const preloadCriticalRoutes = () => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      preloadRoute('/shop');
      preloadRoute('/product');
      preloadRoute('/cart');
    });
  } else {
    // Fallback for browsers that don't support requestIdleCallback
    setTimeout(() => {
      preloadRoute('/shop');
      preloadRoute('/product');
      preloadRoute('/cart');
    }, 2000);
  }
};
